import React, { forwardRef, useContext, useState } from 'react';
import { Box, Divider, ListItemIcon, ListItemText, MenuItem, Paper, Typography } from '@mui/material';
import styles from '../trackfavmenu.module.css';
import { ReactComponent as DeleteIcon } from '../../assets/icons/ic_action_delete_outlined.svg';
import { ReactComponent as RenameIcon } from '../../assets/icons/ic_action_edit_outlined.svg';
import DeleteWptDialog from '../../dialogs/favorites/DeleteWptDialog';
import FavoritesManager, { findSelectedWpt, isNoValue, resolveWptAppearance } from '../../manager/FavoritesManager';
import AppContext from '../../context/AppContext';
import { useTranslation } from 'react-i18next';

const FavoriteItemActions = forwardRef(({ marker, group, setOpenActions }, ref) => {
    const ctx = useContext(AppContext);
    const { t } = useTranslation();

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const favorite = getFavorite();

    function getFavorite() {
        const mapObj = ctx.favorites.mapObjs[group.id];
        const wpt = findSelectedWpt(marker, mapObj.wpts);
        if (wpt) {
            const appearance = resolveWptAppearance(wpt, mapObj.pointsGroups);
            return {
                name: wpt.name,
                groupId: group.id,
                desc: isNoValue(wpt.desc) ? '' : wpt.desc,
                comment: wpt.ext.comment,
                address: isNoValue(wpt.address) ? '' : wpt.address,
                category: wpt.category ? wpt.category : FavoritesManager.DEFAULT_GROUP_NAME,
                ...appearance,
                lat: wpt.lat,
                lon: wpt.lon,
                time: wpt.ext.time,
                point: wpt,
                pointIndex: mapObj.wpts.indexOf(wpt),
                group: group,
            };
        } else {
            return null;
        }
    }

    return (
        <>
            <Box ref={ref}>
                <Paper id="se-fav-item-actions" className={styles.actions}>
                    <MenuItem
                        id={'se-edit-fav-item'}
                        className={styles.action}
                        onClick={() => {
                            const action = () => {
                                ctx.setAddFavorite({ editWpt: favorite, openKey: Date.now() });
                                setOpenActions(false);
                            };
                            if (ctx.exitGuards.wptEdit) {
                                ctx.exitGuards.wptEdit.guard(action);
                            } else {
                                action();
                            }
                        }}
                    >
                        <ListItemIcon className={styles.iconAction}>
                            <RenameIcon />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography className={styles.actionName} noWrap>
                                {t('shared_string_edit')}
                            </Typography>
                        </ListItemText>
                    </MenuItem>
                    <Divider className={styles.dividerActions} />
                    <MenuItem
                        id={'se-delete-fav-item'}
                        className={styles.action}
                        onClick={() => setOpenDeleteDialog(true)}
                    >
                        <ListItemIcon className={styles.iconAction}>
                            <DeleteIcon />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography className={styles.actionName} noWrap>
                                {t('shared_string_delete')}
                            </Typography>
                        </ListItemText>
                    </MenuItem>
                </Paper>
            </Box>
            {openDeleteDialog && (
                <DeleteWptDialog
                    dialogOpen={openDeleteDialog}
                    setDialogOpen={setOpenDeleteDialog}
                    wpt={favorite}
                    setOpenActions={setOpenActions}
                />
            )}
        </>
    );
});

FavoriteItemActions.displayName = 'FavoriteItemActions';
export default FavoriteItemActions;
